import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  CircularProgress,
  Button,
  IconButton,
  Box,
  Divider,
  Chip,
  Avatar,
  Paper
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BadgeIcon from "@mui/icons-material/Badge";
import SchoolIcon from "@mui/icons-material/School";

// Helper para renderizar los campos de datos uniformemente
const DataField = ({ label, value }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, display: "block", textTransform: "uppercase", letterSpacing: 0.5 }}>
      {label}
    </Typography>
    <Typography variant="body2" color="text.primary" sx={{ fontWeight: 500 }}>
      {value || "N/A"}
    </Typography>
  </Box>
);

export default function CedulaModal({ open, onClose, loading, datos }) {
  const nombreCompleto = datos 
    ? `${datos.nombre || ""} ${datos.primerApellido || ""} ${datos.segundoApellido || ""}`.trim()
    : "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: { borderRadius: 3, p: 1 }
      }}
    >
      {/* Encabezado con Botón de Cierre */}
      <DialogTitle sx={{ m: 0, p: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <SchoolIcon color="primary" />
          <Typography variant="h6" fontWeight="bold">
            Detalles de la Cédula
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small" aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ p: 3 }}>
        {loading ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", py: 6, gap: 2 }}>
            <CircularProgress size={40} thickness={4} />
            <Typography variant="body2" color="text.secondary">
              Cargando información...
            </Typography>
          </Box>
        ) : datos ? (
          <Box>
            {/* Tarjeta Destacada con Nombre y Cédula */}
            <Paper 
              elevation={0} 
              sx={{ 
                p: 2.5, 
                mb: 3, 
                backgroundColor: "action.hover", 
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                display: "flex",
                alignItems: "center",
                gap: 2
              }}
            >
              <Avatar sx={{ bgcolor: "primary.main", width: 50, height: 50 }}>
                <BadgeIcon />
              </Avatar>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="subtitle1" fontWeight="bold">
                  {nombreCompleto || "Sin Nombre"}
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                  <Typography variant="caption" color="text.secondary">
                    Cédula:
                  </Typography>
                  <Chip 
                    label={datos.cedula || "Sin cédula"} 
                    size="small" 
                    color="primary" 
                    variant="outlined" 
                    sx={{ fontWeight: "bold" }}
                  />
                </Box>
              </Box>
            </Paper>

            {/* Grid de Información Técnica */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <DataField label="Profesión" value={datos.profesion} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataField label="Carrera" value={datos.carrera} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataField label="Nivel Educativo" value={datos.nivelEducativo} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataField label="Institución" value={datos.institucion} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataField label="Entidad Institución" value={datos.entidadInstitucion} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataField label="Fecha de Titulación" value={datos.fechaTitulacion} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataField label="Fecha de Expedición" value={datos.fechaExpedicion} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataField label="Área de Conocimiento" value={datos.areaConocimiento} />
              </Grid>
              <Grid item xs={12}>
                <DataField label="Subárea de Conocimiento" value={datos.subareaConocimiento} />
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Box sx={{ py: 4, textAlign: "center" }}>
            <Typography color="text.secondary" variant="body2">
              No hay datos disponibles en este momento. Favor de consultar más tarde o consultar la cédula manualmente.
            </Typography>
          </Box>
        )}
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="contained" color="primary" disableElevation>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
